jQuery = require('jquery');

require('select2');